module.exports = __webpack_public_path__ + "../public/img/cores-03.e2ab4cb8.svg";